var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BrowserPermission from '../../enums/browserPermission';
import { useEffect, useState } from 'react';
// This hook can be used to fetch the current state of whether or not notification
// permission has been granted by the human to the browser.
export default function useNotificationPermission() {
    const [browserPermission, setBrowserPermission] = useState(BrowserPermission.Loading);
    // Setup the hook, and listen for changes.
    useEffect(() => {
        if (!window.Notification || !('permissions' in navigator)) {
            setBrowserPermission(BrowserPermission.Unsupported);
            return;
        }
        let unregistered = false;
        let permissionStatus;
        const eventHandler = () => {
            if (!permissionStatus) {
                // The useEffect has been "disposed", do nothing.
                return;
            }
            switch (permissionStatus.state) {
                case 'prompt':
                    setBrowserPermission(BrowserPermission.RequiresPermission);
                    return;
                case 'granted':
                    setBrowserPermission(BrowserPermission.Granted);
                    return;
                case 'denied':
                    setBrowserPermission(BrowserPermission.Denied);
                    return;
                default:
                    console.error('Unrecognized permission state:', permissionStatus.state);
                    setBrowserPermission(BrowserPermission.Error);
                    return;
            }
        };
        navigator.permissions
            .query({ name: 'notifications' })
            .then((permission) => {
            if (unregistered) {
                return;
            }
            permissionStatus = permission;
            permission.addEventListener('change', eventHandler);
            eventHandler();
        })
            .catch((err) => {
            if (unregistered) {
                return;
            }
            console.error('Failed to query notifications permission', err);
            setBrowserPermission(BrowserPermission.Error);
        });
        return () => {
            unregistered = true;
            permissionStatus === null || permissionStatus === void 0 ? void 0 : permissionStatus.removeEventListener('change', eventHandler);
            permissionStatus = null;
        };
    }, []);
    // Allow consumers of the hook to request the permission to be set.
    const requestPermission = () => __awaiter(this, void 0, void 0, function* () {
        yield Notification.requestPermission();
    });
    return [browserPermission, requestPermission];
}
